export const sectionTitleSx = {
    fontWeight: 700,
    fontSize: 17,
    mb: 2,
    color: "#1f3a2e",
    letterSpacing: 0.7,
    background: "linear-gradient(135deg, #2fbf71 0%, #27a864 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text"
};

export const labelSx = {
    fontSize: 10,
    color: "#888",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginBottom: "6px"
};

export const valueSx = {
    fontSize: 14,
    fontWeight: 700,
    color: "#1f3a2e"
};

export const pillSx = {
    px: 1.5,
    py: 0.7,
    fontSize: 11,
    bgcolor: "linear-gradient(135deg, #2fbf71 0%, #27a864 100%)",
    color: "#2fbf71",
    borderRadius: "24px",
    fontWeight: 700,
    boxShadow: "0 4px 12px rgba(47,191,113,0.35)",
    letterSpacing: 0.3
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const formatDate = (value: any) => {
    if (!value) return "—";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return d.toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
    });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const formatDateOnly = (value: any) => {
    if (!value) return "—";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return d.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric"
    });
};
